import { Breadcrumbs as MuiBreadcrumbs, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { useNavigationRoutes } from '~/application/hooks';

export const Breadcrumbs = () => {
    const routes = useNavigationRoutes();

    return (
        <MuiBreadcrumbs>
            {routes.map(({ Icon, id, path, Title, title }, index) => {
                const renderedTitle = Title ? <Title /> : title;

                const content = renderedTitle ? (
                    <Stack key={id} direction="row" alignItems="center" spacing={0.75}>
                        {Icon && <Icon style={{ color: 'inherit', fontSize: '0.9375rem' }} />}
                        <Typography variant="h6" color="text.secondary">
                            {renderedTitle}
                        </Typography>
                    </Stack>
                ) : null;

                return content && path && index < routes.length - 1 && !path.startsWith(':')
                    ? <Link key={id} component={RouterLink} to={path} color="inherit" sx={{ display: 'flex' }}>{content}</Link>
                    : content;
            })}
        </MuiBreadcrumbs>
    );
};


